module.exports = __webpack_public_path__ + "media/images/icons/resend-4ed03381e55d027797477ae41eb10454.png";